export enum KsefDocumentStatus {
    Unknown = 'Unknown',
    ToSend = 'ToSend',
    InvalidSchema = 'InvalidSchema',
    InProgress = 'InProgress',
    SendingError = 'SendingError',
    Rejected = 'Rejected',
    Registered = 'Registered'
}
